import { render, staticRenderFns } from "./DocumentDownloadProvider.vue?vue&type=template&id=8342bf98&scoped=true&"
import script from "./DocumentDownloadProvider.vue?vue&type=script&lang=ts&"
export * from "./DocumentDownloadProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8342bf98",
  null
  
)

export default component.exports